import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
  InputNumber,
  Switch,
} from "antd";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../product.config";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const EditCasa = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  const isWithHoldTax = Form.useWatch("withHoldTax", useForm);
  const checkAllowOverdraft = Form.useWatch("allowOverdraft", useForm);
  const checkForfeitInterest = Form.useWatch("forfeitInterest", useForm);
  // const checkLienAllowed = Form.useWatch("lienAllowed", useForm);
  const checkWithHoldTax = Form.useWatch("withHoldTax", useForm);
  const checkIsDormancyTracking = Form.useWatch("isDormancyTrackingActive", useForm);
  const interestPostingPeriodType = Form.useWatch("interestPostingPeriodType", useForm);
  const interestPostingTypeIsMonthly = interestPostingPeriodType === 4;
  // CHARGES FORM REQURED VARIABLES
  const [fundCount, setFundCount] = useState(1);
  const [feeCount, setFeeCount] = useState(0);
  const [penaltyCount, setPenaltyCount] = useState(0);
  const [chargeTableCount, setChargeTableCount] = useState(0);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [configureFundTableSource, setConfigureFundTableSource] = useState([]);
  const [mapFeeTableSource, setMapFeeTableSource] = useState([]);
  const [mapPenaltyTableSource, setMapPenaltyTableSource] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [currencyData, setCurrencyData] = useState([]);
  const [interestCompoundingPeriodTypeOptions, setInterestCompoundingPeriodTypeOptions] = useState(
    []
  );
  const [interestPostingPeriodTypeOptions, setInterestPostingPeriodTypeOptions] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] = useState([]);
  const [interestCalculationDaysInYearTypeOptions, setInterestCalculationDaysInYearTypeOptions] =
    useState([]);
  const [lockinPeriodFrequencyTypeOptions, setLockinPeriodFrequencyTypeOptions] = useState([]);

  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);

  const [isWithholdTaxValue, setIsWithholdTaxValue] = useState(null);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);
  const [chargeList, setChargeList] = useState([]);
  const [isChargeModalOpen, setIsChargeModalOpen] = useState(false);
  const [isFundSourceModalOpen, setIsFundSourceModalOpen] = useState(false);
  const [isMapFeeModalOpen, setIsMapFeeeModalOpen] = useState(false);
  const [isMapPenaltyModalOpen, setIsMapPenaltyModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerInfo: null,
    customerAddressInfo: null,
  });
  const [casaDetail, setCasaDetail] = useState([]);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeBasedOnCurrencyList, setChargeBasedOnCurrencyList] = useState([]);

  const [currency, setCurrency] = useState("");
  // ACCOUNTING FORM REQUIRED VARIABLES
  const [accountingRuleCheck, setAccountingRuleCheck] = useState("1");
  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [equityAccountOptions, setEquityAccountOptions] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
  }, []);

  const onChangeCurrency = (currencyParam) => {
    setCurrency(currencyParam);
    const chargeForTableData = chargesOptions.filter((item) => item.currencyCode === currencyParam);
    useForm.setFieldsValue({
      chargeId: "",
    });
    setChargeBasedOnCurrencyList([...chargeForTableData]);
  };

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${apiConfig.GetCasaProductList}/${params.key}?template=true`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        let tempCurrency = [];
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesList = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];
        let temPaymentChannelToFundSourceMappings = [];
        let tempFeeToIncomeAccountMappings = [];
        let tempPenaltyToIncomeAccountMappings = [];
        setCasaDetail(objDetail);

        // INITALIZE FORM VALUES FROM ENDPOINT
        useForm.setFieldsValue({
          // details
          name: objDetail?.name,
          shortName: objDetail?.shortName,
          description: objDetail?.description,
          forfeitInterest: objDetail?.forfeitInterest,
          withdrawalCount: objDetail?.maxAllowedWithdrawalCount,
          withdrawalCountPeriodInMonths: objDetail?.maxAllowedWithdrawalCountPeriod,
          // currency
          currencyCode: objDetail?.currency?.code,
          currencyValue: objDetail?.currency?.code,
          digitsAfterDecimal: objDetail?.currency?.decimalPlaces,
          inMultiplesOf: objDetail?.currency?.inMultiplesOf,
          // Terms
          nominalAnnualInterestRate: objDetail?.nominalAnnualInterestRate,
          interestCompoundingPeriodType: objDetail?.interestCompoundingPeriodType.id,
          interestPostingPeriodType: objDetail?.interestPostingPeriodType.id,
          interestCalculationType: objDetail?.interestCalculationType.id,
          interestCalculationDaysInYearType: objDetail?.interestCalculationDaysInYearType.id,
          // Settings
          minRequiredBalance: objDetail?.minRequiredBalance,
          maxAllowedLienLimit: objDetail?.maxAllowedLienLimit,
          withdrawalFeeForTransfers: objDetail?.withdrawalFeeForTransfers,
          minOverdraftForInterestCalculation: objDetail?.minOverdraftForInterestCalculation,
          nominalAnnualInterestRateOverdraft: objDetail?.nominalAnnualInterestRateOverdraft,
          minRequiredOpeningBalance: objDetail?.minRequiredOpeningBalance,
          enforceMinRequiredBalance: objDetail?.enforceMinRequiredBalance,
          allowOverdraft: objDetail?.allowOverdraft,
          lienAllowed: objDetail?.lienAllowed,
          withHoldTax: objDetail?.withHoldTax,
          daysToEscheat: objDetail?.daysToEscheat,
          daysToDormancy: objDetail?.daysToDormancy,
          daysToInactive: objDetail?.daysToInactive,
          isDormancyTrackingActive: objDetail?.isDormancyTrackingActive,
          lockinPeriodFrequency: objDetail?.lockinPeriodFrequency
            ? objDetail?.lockinPeriodFrequency
            : "",
          lockinPeriodFrequencyType: objDetail?.lockinPeriodFrequencyType
            ? objDetail?.lockinPeriodFrequencyType.id
            : "",
          overdraftLimit: objDetail?.overdraftLimit,
          // Accounting
          savingsReferenceAccountId: objDetail?.accountingMappings?.savingsReferenceAccount?.id,

          overdraftPortfolioControlId: objDetail?.accountingMappings?.overdraftPortfolioControl?.id,

          savingsControlAccountId: objDetail?.accountingMappings?.savingsControlAccount?.id,

          transfersInSuspenseAccountId:
            objDetail?.accountingMappings?.transfersInSuspenseAccount?.id,

          interestOnSavingsAccountId: objDetail?.accountingMappings?.interestOnSavingsAccount?.id,

          writeOffAccountId: objDetail?.accountingMappings?.writeOffAccount?.id,

          incomeFromFeeAccountId: objDetail?.accountingMappings?.incomeFromFeeAccount?.id,

          incomeFromPenaltyAccountId: objDetail?.accountingMappings?.incomeFromPenaltyAccount?.id,

          incomeFromInterestId: objDetail?.accountingMappings?.incomeFromInterest?.id,

          escheatLiabilityId: objDetail?.accountingMappings?.escheatLiabilityAccount?.id,
        });

        const currency = objDetail?.currency?.code;
        setCurrency(currency);
        // STRICT VALUES FOR ACCOUNTING FORM
        let tempAccountingRule = "" + objDetail?.accountingRule?.id;
        setAccountingRuleCheck(tempAccountingRule);

        // ATTACHING OPTIONS FROM END POINT
        objDetail?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.name,
            decimalPlaces: element.decimalPlaces,
          });
        });
        objDetail?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.interestCalculationDaysInYearTypeOptions?.forEach((element) => {
          tempInterestCalculationDaysInYearTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.accountingMappingOptions?.assetAccountOptions?.forEach((element) => {
          tempAssetOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objDetail?.accountingMappingOptions?.equityAccountOptions?.forEach((element) => {
          tempEquityOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objDetail?.accountingMappingOptions?.expenseAccountOptions?.forEach((element) => {
          tempExpenseOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objDetail?.accountingMappingOptions?.incomeAccountOptions?.forEach((element) => {
          tempIncomeOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objDetail?.accountingMappingOptions?.liabilityAccountOptions?.forEach((element) => {
          tempLiabilityOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesList.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? element?.amount : "-",
            collectedOn: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
          });
        });

        objDetail?.paymentChannelToFundSourceMappings?.forEach((element, index) => {
          temPaymentChannelToFundSourceMappings.push({
            key: index,
            id: index,
            fundSourceAccountId: element?.fundSourceAccount.id,
            fundSourceAccountValue: element?.fundSourceAccount.name,
            paymentTypeId: element?.paymentType?.id,
            paymentTypeValue: element?.paymentType?.name,
          });
        });

        objDetail?.feeToIncomeAccountMappings?.forEach((element, index) => {
          tempFeeToIncomeAccountMappings.push({
            key: index,
            id: index,
            incomeAccountId: element?.incomeAccount?.id,
            incomeAccountValue: element?.incomeAccount?.name,
            chargeId: element.charge?.id,
            chargeValue: element?.charge?.name,
          });
        });

        // objDetail?.paymentChannelToFundSourceMappings?.forEach(
        //   (element, index) => {
        //     tempPenaltyToIncomeAccountMappings.push({
        //       key: index,
        //       id: index,
        //       fundSourceAccountId: element?.paymentType?.fundSourceAccount.id,
        //       fundSourceAccountValue:
        //         element?.paymentType?.fundSourceAccount.name,
        //       paymentTypeId: element?.paymentType?.paymentType.id,
        //       paymentTypeValue: element?.paymentType?.paymentType.name,
        //     });
        //   }
        // );

        objDetail?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objDetail?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(tempInterestCompoundingPeriodTypeOptions);
        setInterestPostingPeriodTypeOptions(tempInterestPostingPeriodTypeOptions);
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(tempInterestCalculationDaysInYearTypeOptions);
        setLockinPeriodFrequencyTypeOptions(tempLockinPeriodFrequencyTypeOptions);
        setTaxGroupOptions(tempTaxGroupOptions);
        setAssetAccountOptions(tempAssetOptions);
        setEquityAccountOptions(tempEquityOptions);
        setExpenseAccountOptions(tempExpenseOptions);
        setIncomeAccountOptions(tempIncomeOptions);
        setLiabilityAccountOptions(tempLiabilityOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);
        setChargeTableSource(tempChargesList);
        setCharges(tempCharges);
        setChargesOptions(tempChargesOptions);
        setPenaltyOptions(tempPenaltyOptions);
        let tempChargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === objDetail?.currency?.code
        );

        setChargeBasedOnCurrencyList(tempChargeForTableData);
        setConfigureFundTableSource(temPaymentChannelToFundSourceMappings);
        setMapFeeTableSource(tempFeeToIncomeAccountMappings);
        setMapPenaltyTableSource(tempPenaltyToIncomeAccountMappings);
        setIsLoading(false);

        setFormData(useForm.getFieldsValue(true));
      }
    });
  };

  const filteredAssetAccountOptions = assetAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredEquityAccountOptions = equityAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredExpenseAccountOptions = expenseAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredIncomeAccountOptions = incomeAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredLiabilityAccountOptions = liabilityAccountOptions.filter(
    (item) => item.currencyCode === currency
  );

  function onCancel() {
    navigate("/prd0100", { state: state });
  }

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleFundSourceDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = configureFundTableSource.filter((item) => item.id !== key.id);
        setConfigureFundTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleMapFeeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.incomeAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = mapFeeTableSource.filter((item) => item.id !== key.id);
        setMapFeeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleMapPenaltyDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.incomeAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = mapPenaltyTableSource.filter((item) => item.id !== key.id);
        setMapPenaltyTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    [
      {
        title: "Name",
        dataIndex: "name",
      },
      {
        title: "Type",
        dataIndex: "type",
      },
      {
        title: "Amount",
        dataIndex: "amount",
      },
      {
        title: "Collected On",
        dataIndex: "collectedOn",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          chargeTableSource.length >= 1 ? (
            <Tooltip title={`Remove Charge`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleChargeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Payment Type",
        //   dataIndex: "paymentTypeId",
        dataIndex: "paymentTypeValue",
      },
      {
        title: "Fund Source",
        //   dataIndex: "fundSourceAccountId",
        dataIndex: "fundSourceAccountValue",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          configureFundTableSource.length >= 1 ? (
            <Tooltip title={`Remove`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleFundSourceDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Fees",
        dataIndex: "chargeValue",
      },
      {
        title: "Income Account",
        dataIndex: "incomeAccountValue",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          mapFeeTableSource.length >= 1 ? (
            <Tooltip title={`Remove`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleMapFeeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Penalty",
        dataIndex: "penaltyValue",
      },
      {
        title: "Income Account",
        dataIndex: "incomeAccountValue",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          mapPenaltyTableSource.length >= 1 ? (
            <Tooltip title={`Remove`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleMapPenaltyDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
  ];

  const onSubmit = (formValues) => {
    let tempChargeArray = [];
    let tempPaymentChannelToFundSourceMappingsArray = [];
    let tempFeeToIncomeAccountMappingsArray = [];
    let tempPenaltyToIncomeAccountMappingsArray = [];

    chargeTableSource.forEach((element) => {
      tempChargeArray.push({
        id: element.id,
      });
    });

    configureFundTableSource.forEach((element, index) => {
      tempPaymentChannelToFundSourceMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    mapFeeTableSource.forEach((element, index) => {
      tempFeeToIncomeAccountMappingsArray.push({
        chargeId: element.chargeId,
        incomeAccountId: element.incomeAccountId,
      });
    });

    mapPenaltyTableSource.forEach((element, index) => {
      tempPenaltyToIncomeAccountMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    formValues.accountingRule = "2";
    formValues.charges = tempChargeArray;
    formValues.paymentChannelToFundSourceMappings = tempPaymentChannelToFundSourceMappingsArray;
    formValues.feeToIncomeAccountMappings = tempFeeToIncomeAccountMappingsArray;
    formValues.penaltyToIncomeAccountMappings = tempPenaltyToIncomeAccountMappingsArray;

    // nominalAnnualInterestRateOverdraft;
    // overdraftLimit;

    // console.log(formValues);
    // return;

    const url = `${apiConfig.EditCasaProductList}/${state.key}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    // console.log(body);
    // return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editCasaCreatedMsg);
          navigate("/view-prd0100", { state: state });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd0100");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={"Edit CASA Product"} pageItems={[]} />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              isPenalty: false,
              // chargeAppliesTo: 2,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {"CASA Product Setup"}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Product Name</Text>}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Product Name"></Input>
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Short Name</Text>}
                  name="shortName"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Short Name"></Input>
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Description</Text>}
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input.TextArea></Input.TextArea>
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Currency</Text>}
                  name={"currencyCode"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    options={currencyData}
                    onChange={onChangeCurrency}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Decimal Places</Text>}
                  name={"digitsAfterDecimal"}
                  // initialValue={currencyData[0]?.decimalPlaces}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Multiples Of</Text>}
                  name={"inMultiplesOf"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.interestInformation}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Nominal Annual Interest(%)</Text>}
                  name={"nominalAnnualInterestRate"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestCompoundingPeriod}
                  name={"interestCompoundingPeriodType"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestCompoundingPeriod,
                      "select"
                    )}
                    options={interestCompoundingPeriodTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestPostingPeriod}
                  name={"interestPostingPeriodType"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestPostingPeriod,
                      "select"
                    )}
                    options={interestPostingPeriodTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {interestPostingTypeIsMonthly && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item name={"forfeitInterest"} label={"Forfeit Interest for Withdrawals"}>
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        showSearch
                        allowClear
                        placeholder="Select Option"
                        options={staticConfig.yesOrNo}
                        // onChange={handleDormancyTracking}
                      />
                    </Form.Item>
                  </Col>
                  {checkForfeitInterest && (
                    <>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld("Number of Withdrawals Threshold"),
                            },
                          ]}
                          label={"Number of Withdrawals Threshold"}
                          name={"withdrawalCount"}
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestCalculatedUsing}
                  name={"interestCalculationType"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestCalculatedUsing,
                      "select"
                    )}
                    options={interestCalculationTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.daysInYear}
                  name={"interestCalculationDaysInYearType"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.daysInYear),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.daysInYear, "select")}
                    options={interestCalculationDaysInYearTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {"Settings"}
                </Title>
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Minimum Opening Balance</Text>}
                  name={"minRequiredOpeningBalance"}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.lockInPeriod} name={"lockinPeriodFrequency"}>
                  <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label="Lock-In Period Frequency Type" name="lockinPeriodFrequencyType">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod, "select")}
                    options={lockinPeriodFrequencyTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name={"withdrawalFeeForTransfers"}
                  label={
                    <Tooltip title={"Apply Withdrawal Fee For Transfers?"}>
                      {BOM.SubstringFormat("Apply Withdrawal Fee For Transfers?", 20)}
                    </Tooltip>
                  }
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    placeholder="Select Option"
                    options={staticConfig.yesOrNoData}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Tooltip title={"Balance Required For Interest Calculation"}>
                      {BOM.SubstringFormat("Balance Required For Interest Calculation", 20)}
                    </Tooltip>
                  }
                  name={"minBalanceForInterestCalculation"}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name={"enforceMinRequiredBalance"}
                  label={<Text>Enforce Minimum Balance?</Text>}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    placeholder="Select Option"
                    options={staticConfig.yesOrNoData}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text>Minimum Balance</Text>} name={"minRequiredBalance"}>
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name={"allowOverdraft"} label={<Text>Is Overdraft Allowed?</Text>}>
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    placeholder="Select Option"
                    options={staticConfig.yesOrNo}
                  />
                </Form.Item>
              </Col>

              {checkAllowOverdraft && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Maximum Overdraft Amount Limit"}>
                        {BOM.SubstringFormat("Maximum Overdraft Amount Limit", 20)}
                      </Tooltip>
                    }
                    name={"overdraftLimit"}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}
              {checkAllowOverdraft && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Nominal Annual Interest For Overdraft?"}>
                        {BOM.SubstringFormat("Nominal Annual Interest For Overdraft?", 20)}
                      </Tooltip>
                    }
                    name={"nominalAnnualInterestRateOverdraft"}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}

              {checkAllowOverdraft && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Min Overdraft Required For Interest Calculation"}>
                        {BOM.SubstringFormat("Min Overdraft Required For Interest Calculation", 20)}
                      </Tooltip>
                    }
                    name={"minOverdraftForInterestCalculation"}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}
              {/* <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name={"lienAllowed"} label={<Text>Is Lien Allowed?</Text>}>
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    placeholder="Select Option"
                    options={staticConfig.yesOrNo}
                  />
                </Form.Item>
              </Col>

              {checkLienAllowed && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Maximum Lien Amount Limit"}>
                        {BOM.SubstringFormat("Maximum Lien Amount Limit", 20)}
                      </Tooltip>
                    }
                    name={"maxAllowedLienLimit"}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )} */}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name={"withHoldTax"} label={<Text>Is Withhold Tax Applicable?</Text>}>
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    placeholder="Select Option"
                    options={staticConfig.yesOrNo}
                  />
                </Form.Item>
              </Col>

              {checkWithHoldTax && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text>Tax Group</Text>} name={"taxGroupId"}>
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                      }
                      showSearch
                      options={taxGroupOptions}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name={"isDormancyTrackingActive"}
                  label={<Text>Enable Dormancy Tracking ?</Text>}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    showSearch
                    placeholder="Select Option"
                    options={staticConfig.yesOrNo}
                  />
                </Form.Item>
              </Col>
              {checkIsDormancyTracking && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Number of Days to Inactive Sub-status ?"}>
                        {BOM.SubstringFormat("Number of Days to Inactive Sub-status ?", 20)}
                      </Tooltip>
                    }
                    name={"daysToInactive"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld("Number of Days to Inactive Sub-status"),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}
              {checkIsDormancyTracking && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Number of Days to Dormant Sub-status ?"}>
                        {BOM.SubstringFormat("Number of Days to Dormant Sub-status ?", 20)}
                      </Tooltip>
                    }
                    name={"daysToDormancy"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld("Number of Days to Dormant Sub-status"),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}
              {checkIsDormancyTracking && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={"Number of Days to Escheat"}>
                        {BOM.SubstringFormat("Number of Days to Escheat", 20)}
                      </Tooltip>
                    }
                    name={"daysToEscheat"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld("Number of Days to Escheat"),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              )}

              {isWithholdTaxValue && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>{labelConfig.isWithholdTax}</Text>}
                      name={"withHoldTax"}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        placeholder="Select one"
                        options={staticConfig.yesOrNoData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  {isWithHoldTax && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={<Text>{labelConfig.taxGroup}</Text>} name={"taxGroup"}>
                        <Input disabled className="of-bold-disable-input" />
                      </Form.Item>
                    </Col>
                  )}
                </>
              )}
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.chargeInfo}
              </Title>
            </Divider>
            <ChargeModal
              isChargeModalOpen={isChargeModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsChargeModalOpen={setIsChargeModalOpen}
              chargeData={chargeBasedOnCurrencyList}
              setChargeList={setChargeList}
              setChargeTableSource={setChargeTableSource}
              chargeTableSource={chargeTableSource}
              chargeList={chargeList}
              session={session}
            />

            {chargeTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {chargeTableSource.length > 1
                      ? labelConfig.selectedCharges
                      : labelConfig.selectedCharge}
                  </Title>
                </Divider>
                <Table
                  columns={columns[0]}
                  dataSource={chargeTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {"Accounting Information"}
              </Title>
            </Divider>
            <div>
              <div>
                <Title level={4}>Assets</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text> Savings Reference</Text>}
                      name="savingsReferenceAccountId"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Required Field",
                      //   },
                      // ]}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredAssetAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="overdraftPortfolioControlId"
                      label={<Text>Overdraft Portfolio</Text>}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredAssetAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div>
                <Title level={4}>Liabilities</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item name="savingsControlAccountId" label={<Text>Savings Control</Text>}>
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredLiabilityAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="transfersInSuspenseAccountId"
                      label={<Text>Savings Transfers In Suspense </Text>}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredLiabilityAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  {checkIsDormancyTracking && (
                    <Col span={12} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="escheatLiabilityId"
                        label={labelConfig.escheatLiability}
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.escheatLiability),
                          },
                        ]}
                      >
                        <Select
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                          }
                          options={filteredLiabilityAccountOptions}
                          placeholder={"Select an Option"}
                          allowClear
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </div>
              <div>
                <Title level={4}>Expenses</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="interestOnSavingsAccountId"
                      label={<Text>Interest On Savings</Text>}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredExpenseAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item name="writeOffAccountId" label={<Text>Write-off</Text>}>
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredExpenseAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div>
                <Title level={4}>Income</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item name="incomeFromFeeAccountId" label={<Text>Income From Fees</Text>}>
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredIncomeAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="incomeFromPenaltyAccountId"
                      label={<Text>Income From Penalties</Text>}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredIncomeAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="incomeFromInterestId"
                      label={<Text>Overdraft Interest Income</Text>}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        options={filteredIncomeAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <Title level={4}>
                Advanced Accounting Rule:{" "}
                <span>
                  {showAdvancedAccounting ? (
                    <>
                      <Button
                        type="dashed"
                        onClick={() => setShowAdvancedAccounting(!showAdvancedAccounting)}
                        icon={<DownOutlined />}
                      >
                        Hide
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        type="dashed"
                        onClick={() => setShowAdvancedAccounting(!showAdvancedAccounting)}
                        icon={<RightOutlined />}
                      >
                        Show
                      </Button>
                    </>
                  )}
                </span>
              </Title>
              {/* <Divider style={{ margin: 0, padding: 0 }} /> */}
              {showAdvancedAccounting && (
                <div>
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      Configure Fund Sources for Payment Channels
                    </Title>
                  </Divider>
                  <FundSourceModal
                    isFundSourceModalOpen={isFundSourceModalOpen}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setIsFundSourceModalOpen={setIsFundSourceModalOpen}
                    paymentTypeOptions={paymentTypeOptions}
                    assetAccountOptions={assetAccountOptions}
                    setConfigureFundTableSource={setConfigureFundTableSource}
                    configureFundTableSource={configureFundTableSource}
                    session={session}
                    fundCount={fundCount}
                    setFundCount={setFundCount}
                  />

                  {configureFundTableSource?.length > 0 && (
                    <>
                      <Divider orientation="left" orientationMargin="0">
                        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                          {configureFundTableSource.length > 1
                            ? "Selected Fund Sources"
                            : "Selected Fund Source"}
                        </Title>
                      </Divider>
                      <Table
                        columns={columns[1]}
                        dataSource={configureFundTableSource}
                        bordered
                        pagination={{
                          position: "bottomCentre",
                          pageSize: "10",
                        }}
                      />
                    </>
                  )}
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      Map Fees to Income Accounts
                    </Title>
                  </Divider>
                  <MapFeeModal
                    isMapFeeModalOpen={isMapFeeModalOpen}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setIsMapFeeeModalOpen={setIsMapFeeeModalOpen}
                    charges={charges}
                    incomeAccountOptions={incomeAccountOptions}
                    setMapFeeTableSource={setMapFeeTableSource}
                    mapFeeTableSource={mapFeeTableSource}
                    session={session}
                    feeCount={feeCount}
                    setFeeCount={setFeeCount}
                  />

                  {mapFeeTableSource?.length > 0 && (
                    <>
                      <Divider orientation="left" orientationMargin="0">
                        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                          {mapFeeTableSource.length > 1
                            ? "Selected Income Accounts"
                            : "Selected Income Account"}
                        </Title>
                      </Divider>
                      <Table
                        columns={columns[2]}
                        dataSource={mapFeeTableSource}
                        bordered
                        pagination={{
                          position: "bottomCentre",
                          pageSize: "10",
                        }}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_SAVINGSPRODUCT") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default EditCasa;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isChargeModalOpen,
    chargeData,
    setIsChargeModalOpen,
    setChargeList,
    chargeList,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsChargeModalOpen(true);
  };
  const handleOk = () => {
    setIsChargeModalOpen(false);
  };
  const handleCancel = () => {
    setIsChargeModalOpen(false);
  };

  const handleChargeSave = (formValues) => {
    const newCharges = {
      key: formValues?.chargeId,
      id: formValues?.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues?.amount,
      amount: (
        <Statistic value={formValues?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
      ),
    };

    let foundCharge = chargeTableSource.find((item) => item.id === newCharges?.id);
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setChargeTableSource([...chargeTableSource, newCharges]);

    useForm.resetFields();
  };

  const handleSelectedCharge = (chargeId) => {
    // console.log(chargeId);
    const params = {
      template: "true",
    };

    const url = `${apiConfig.charges}/${chargeId}`;

    const body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          key: objList.id,
          id: objList.id,
          name: objList.name,
          type: objList.chargeCalculationType.value,
          collectedOn: objList?.chargeTimeType.value,
          amount: objList?.amount,
        });

        // STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        className="of-primaryBtnColor"
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        title="Charge Information Setup"
        open={isChargeModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form form={useForm} layout="vertical" onFinish={handleChargeSave} name="address-info">
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Charge Options"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.charge, "select")}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider />
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name={"name"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name={"type"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.collectedOn)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name={"amount"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const FundSourceModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setConfigureFundTableSource,
    configureFundTableSource,
    isFundSourceModalOpen,
    setIsFundSourceModalOpen,
    paymentTypeOptions,
    assetAccountOptions,
    fundCount,
    setFundCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsFundSourceModalOpen(true);
  };
  const handleOk = () => {
    setIsFundSourceModalOpen(false);
  };
  const handleCancel = () => {
    setIsFundSourceModalOpen(false);
  };

  const handleFundSourceSave = (formValues) => {
    const newCharges = {
      key: fundCount,
      id: fundCount,
      fundSourceAccountId: formValues.fundSourceAccountId,
      paymentTypeId: formValues.paymentTypeId,
      paymentTypeValue: paymentTypeOptions.find((item) => item.value === formValues.paymentTypeId)
        .label,
      fundSourceAccountValue: assetAccountOptions.find(
        (item) => item.value === formValues.fundSourceAccountId
      ).label,
    };
    setFundCount(fundCount + 1);
    setConfigureFundTableSource([...configureFundTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        className="of-primaryBtnColor"
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {"Add Fund Source"}
      </Button>

      <Modal
        title="Fund Source Information Setup"
        open={isFundSourceModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleFundSourceSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"paymentTypeId"}
                label={"Payment Type"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Payment Type"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg("Payment Type", "select")}
                  options={paymentTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"fundSourceAccountId"}
                label={"Fund Source"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Fund Source"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg("Fund Source", "select")}
                  options={assetAccountOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const MapFeeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setMapFeeTableSource,
    mapFeeTableSource,
    isMapFeeModalOpen,
    setIsMapFeeeModalOpen,
    charges,
    incomeAccountOptions,
    feeCount,
    setFeeCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsMapFeeeModalOpen(true);
  };
  const handleOk = () => {
    setIsMapFeeeModalOpen(false);
  };
  const handleCancel = () => {
    setIsMapFeeeModalOpen(false);
  };

  const handleMapFeeSave = (formValues) => {
    const newCharges = {
      key: feeCount,
      id: feeCount,
      incomeAccountId: formValues.incomeAccountId,
      chargeId: formValues.chargeId,
      chargeValue: charges.find((item) => item.value === formValues.chargeId).label,
      incomeAccountValue: incomeAccountOptions.find(
        (item) => item.value === formValues.incomeAccountId
      ).label,
    };

    setFeeCount(feeCount + 1);
    setMapFeeTableSource([...mapFeeTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        className="of-primaryBtnColor"
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {"Add Income Account"}
      </Button>

      <Modal
        title="Income Account Information Setup"
        open={isMapFeeModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form form={useForm} layout="vertical" onFinish={handleMapFeeSave} name="address-info">
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Fees"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Fees"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg("Fees", "select")}
                  options={charges}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"incomeAccountId"}
                label={"Income Account"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Income Account"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg("Income Account", "select")}
                  options={incomeAccountOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const MapPenaltyModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setMapPenaltyTableSource,
    mapPenaltyTableSource,
    isMapPenaltyModalOpen,
    setIsMapPenaltyModalOpen,
    penaltyOptions,
    incomeAccountOptions,
    penaltyCount,
    setPenaltyCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsMapPenaltyModalOpen(true);
  };
  const handleOk = () => {
    setIsMapPenaltyModalOpen(false);
  };
  const handleCancel = () => {
    setIsMapPenaltyModalOpen(false);
  };

  const handleMapPenaltySave = (formValues) => {
    const newCharges = {
      key: penaltyCount,
      id: penaltyCount,
      incomeAccountPenalty: formValues.incomeAccountPenalty,
      penalty: formValues.penalty,
      penaltyValue: penaltyOptions.find((item) => item.value === formValues.penalty).label,
      incomeAccountValue: incomeAccountOptions.find(
        (item) => item.value === formValues.incomeAccountPenalty
      ).label,
    };
    setPenaltyCount(penaltyCount + 1);
    setMapPenaltyTableSource([...mapPenaltyTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {"Add Income Account"}
      </Button>

      <Modal
        title="Income Account Information Setup"
        open={isMapPenaltyModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleMapPenaltySave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"penalty"}
                label={"Penalty"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Penalty"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg("Penalty", "select")}
                  options={penaltyOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"incomeAccountPenalty"}
                label={"Income Account"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Income Account"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg("Income Account", "select")}
                  options={incomeAccountOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
